// extracted by mini-css-extract-plugin
export default {"srOnly":"_3hSat","expandedWidget":"-b2Fa","mobile":"sTtQV","floating":"jB8iV","header":"ZD7tN","chatroom":"_2Evtw"};